import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Instagram, Star } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-gray-300">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Company Info */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center space-x-2 group">
              <img 
                src="/logo.png" 
                alt="Kerry M Holloway Agency" 
                className="h-36 w-auto"
              />
            </Link>
            <p className="text-sm text-gray-400 leading-relaxed">
              Affiliated with AIC Insurance since 2009. Real people, real relationships, real coverage that makes sense.
            </p>
            {/* AIC Insurance Logo */}
            <div className="pt-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_policy-manager-59/artifacts/i7potc4i_AIC-Insurance-Logo-500-1.png" 
                alt="AIC Insurance" 
                className="h-16 w-auto opacity-80 hover:opacity-100 transition-opacity"
              />
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-lg">Quick Links</h3>
            <ul className="space-y-3">
              {['Home', 'Services', 'About', 'Contact', 'Get a Quote'].map((item) => (
                <li key={item}>
                  <Link
                    to={item === 'Get a Quote' ? '/quote' : item === 'Home' ? '/' : `/${item.toLowerCase()}`}
                    className="text-sm text-gray-400 hover:text-red-400 transition-colors duration-200 inline-block"
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-lg">Our Services</h3>
            <ul className="space-y-3">
              {['Auto Insurance', 'Life Insurance', 'Business Insurance', 'Policy Review', 'Claims Support'].map((service) => (
                <li key={service}>
                  <Link
                    to="/services"
                    className="text-sm text-gray-400 hover:text-red-400 transition-colors duration-200 inline-block"
                  >
                    {service}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-lg">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Phone className="h-5 w-5 text-[#D94B5A] 500 flex-shrink-0 mt-0.5" />
                <div>
                  <a href="tel:5415488215" data-testid="footer-phone-link" className="text-sm text-gray-400 hover:text-red-400 transition-colors">541-548-8215</a>
                  <p className="text-xs text-gray-500">Mon-Thu 8am-5pm • Fri 8am-3pm</p>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="h-5 w-5 text-[#D94B5A] 500 flex-shrink-0 mt-0.5" />
                <a href="mailto:kholloway@aicinsagency.com" className="text-sm text-gray-400 hover:text-red-400 transition-colors">
                  kholloway@aicinsagency.com
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-[#D94B5A] 500 flex-shrink-0 mt-0.5" />
                <p className="text-sm text-gray-400">
                  2801 NE 3rd St<br />
                  Prineville, OR 97754
                </p>
              </li>
            </ul>
          </div>
        </div>

        {/* Social Media & Copyright */}
        <div className="mt-12 pt-8 border-t border-gray-700">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-400">
              © {currentYear} Kerry M Holloway Insurance Agency. All rights reserved.
            </p>
            <div className="flex items-center space-x-5">
              <a
                href="https://g.page/r/CTz06hog7XU7EAE/review"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-sm text-gray-400 hover:text-red-400 transition-colors duration-200"
                data-testid="footer-google-review-link"
              >
                <Star className="h-4 w-4" />
                Leave a Google Review
              </a>
              <a
                href="https://www.facebook.com/HollowayInsAgency"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-red-400 transition-colors duration-200"
                aria-label="Visit Kerry M Holloway Agency on Facebook"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a
                href="https://www.instagram.com/oregoninslady/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-red-400 transition-colors duration-200"
                aria-label="Visit Kerry M Holloway on Instagram"
              >
                <Instagram className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
